/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfAppDto } from '../../models/platform-api-result-of-app-dto';
import { PlatformUpdateApp } from '../../models/platform-update-app';

export interface PutApps$Params {
      body: PlatformUpdateApp
}

export function putApps(http: HttpClient, rootUrl: string, params: PutApps$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfAppDto>> {
  const rb = new RequestBuilder(rootUrl, putApps.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfAppDto>;
    })
  );
}

putApps.PATH = '/api/apps';
